import { render, staticRenderFns } from "./Terms3.vue?vue&type=template&id=00c180ce&"
import script from "./Terms3.vue?vue&type=script&lang=js&"
export * from "./Terms3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports